import type { UnifiedContext } from '../context';
import { resolveAnchor } from './utilty';

export const handleBuyLink = (el: HTMLElement, ctx: UnifiedContext) => {
  const { storeBuyLink } = el.dataset;
  if (storeBuyLink === undefined) return;
  const option = ctx.option;
  if (!option) return;

  const link = resolveAnchor(el);
  if (!link) return;

  const product = option.getProduct();
  const discountedPrice = option.getDiscountedPrice({ currency: false });
  const fullPrice = option.getPrice({ currency: false });

  link.href = option.getBuyLink();
  link.dataset.product = product.getId();
  link.dataset.buyPrice = discountedPrice ? String(discountedPrice) : String(fullPrice);
  link.dataset.oldPrice = String(fullPrice);
  link.dataset.currency = product.getCurrency();
  link.dataset.variation = `${option.getDevices()}u-${option.getSubscription()}m`;
};
